import { Box, Button, IconButton, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { DeleteOutline } from '@mui/icons-material';
import { useState } from 'react';
import { useFormikContext } from 'formik';
import { FormikTimePicker } from '@/common/presentation/components/forms/fields/FormikTimePicker';
import { RaptorJobFormValues } from '../../../RaptorJobValidationSchema';
import tid from '@/common/infrastructure/config/tid';

export const DailyDispatchTimes = () => {
  const { values, setFieldValue } = useFormikContext<RaptorJobFormValues>();
  const [showUpTimeActive, setShowUpTimeActive] = useState(false);
  const [leaveByTimeActive, setLeaveByTimeActive] = useState(false);
  const [onJobTimeActive, setOnJobTimeActive] = useState(false);

  if (values.recurrence !== 'single') {
    return null;
  }

  return (
    <>
      <Typography variant="h6" sx={{ fontSize: '1rem', mb: 2, fontWeight: 600 }}>
        Daily Dispatch Times
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            columnGap: { xs: '0px', sm: '12px' }
          }}
        >
          {showUpTimeActive && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FormikTimePicker<RaptorJobFormValues>
                id="showUpTime"
                label="Show Up Time"
                sx={{ flex: 1 }}
                {...tid('jobs:create:show-up-time-input')}
              />
              <IconButton
                title="Remove Show Up Time"
                onClick={() => {
                  setShowUpTimeActive(false);
                  setFieldValue('showUpTime', null);
                }}
                sx={{ mb: '20px' }}
                {...tid('jobs:create:remove-show-up-time-button')}
              >
                <DeleteOutline color="error" />
              </IconButton>
            </Box>
          )}
          {leaveByTimeActive && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FormikTimePicker<RaptorJobFormValues>
                id="leaveByTime"
                label="Leave By Time"
                sx={{ flex: 1 }}
                {...tid('jobs:create:leave-by-time-input')}
              />
              <IconButton
                title="Remove Leave By"
                onClick={() => {
                  setLeaveByTimeActive(false);
                  setFieldValue('leaveByTime', null);
                }}
                sx={{ mb: '20px' }}
                {...tid('jobs:create:remove-leave-by-time-button')}
              >
                <DeleteOutline color="error" />
              </IconButton>
            </Box>
          )}

          {onJobTimeActive && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FormikTimePicker<RaptorJobFormValues>
                id="onJobTime"
                label="On Job Time"
                sx={{ flex: 1 }}
                {...tid('jobs:create:on-job-time-input')}
              />
              <IconButton
                title="Remove On Job Time"
                onClick={() => {
                  setOnJobTimeActive(false);
                  setFieldValue('onJobTime', null);
                }}
                sx={{ mb: '20px' }}
                {...tid('jobs:create:remove-on-job-time-button')}
              >
                <DeleteOutline color="error" />
              </IconButton>
            </Box>
          )}
          <FormikTimePicker<RaptorJobFormValues> id="startTime" label="Start Time" testId="jobs:create:start-time-input" />
          <FormikTimePicker<RaptorJobFormValues> id="endTime" label="Est. End Time" testId="jobs:create:end-time-input" />
        </Box>

        {/* Action Buttons for Time Options */}
        <Box sx={{ display: 'flex', gap: 2, mt: 1, flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'flex-start' }}>
          {!showUpTimeActive && (
            <Button
              type="button"
              variant="text"
              onClick={() => setShowUpTimeActive(true)}
              startIcon={<AddCircleOutlineIcon />}
              sx={{ whiteSpace: 'nowrap' }}
              {...tid('jobs:create:add-show-up-time-button')}
            >
              ADD SHOW UP TIME
            </Button>
          )}
          {!leaveByTimeActive && (
            <Button
              type="button"
              variant="text"
              onClick={() => setLeaveByTimeActive(true)}
              startIcon={<AddCircleOutlineIcon />}
              sx={{ whiteSpace: 'nowrap' }}
              {...tid('jobs:create:add-leave-by-time-button')}
            >
              ADD LEAVE BY TIME
            </Button>
          )}
          {!onJobTimeActive && (
            <Button
              type="button"
              variant="text"
              onClick={() => setOnJobTimeActive(true)}
              startIcon={<AddCircleOutlineIcon />}
              sx={{ whiteSpace: 'nowrap' }}
              {...tid('jobs:create:add-on-job-time-button')}
            >
              ADD ON JOB TIME
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};
